<script setup lang="ts">
  import eyeOnIcon from '@/assets/icons/eye-on.svg'
  import eyeOffIcon from '@/assets/icons/eye-off.svg'

  import { useForm } from 'laravel-precognition-vue'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()

  const emit = defineEmits<{
    'on-success': []
  }>()

  const snackbar = ref(false)
  const snackbarText = ref('')
  const snackbarColor = ref('success')

  const showPassword = ref(false)
  const showPasswordConfirmation = ref(false)
  const form = useForm('put', 'users/profile/password', {
    password: null,
    password_confirmation: null,
  })

  const submit = () => form.submit().then(() => {
    emit('on-success')
    snackbarColor.value = 'success'
    snackbarText.value = t('updated_successfully')
    snackbar.value = true
    form.reset()
  })
</script>

<template>
  <v-form class="mt-10" @submit.prevent="submit">
    <v-row>
      <v-col class="py-0" cols="12">
        <div class="text-gray-100 font-weight-medium text-body-2 mb-2">
          <i18n-t keypath="password" />
        </div>
        <v-text-field
          v-model="form.password"
          :append-inner-icon="showPassword ? eyeOnIcon : eyeOffIcon"
          density="compact"
          :error="form.invalid('password')"
          :error-messages="form.errors.password"
          :placeholder="t('password')"
          :type="showPassword ? 'text' : 'password'"
          variant="outlined"
          @click:append-inner="showPassword = !showPassword"
          @click:clear="form.validate('password')"
        />
      </v-col>
      <v-col class="py-0" cols="12">
        <div class="text-gray-100 font-weight-medium text-body-2 mb-2">
          <i18n-t keypath="password_confirmation" />
        </div>
        <v-text-field
          v-model="form.password_confirmation"
          :append-inner-icon="showPasswordConfirmation ? eyeOnIcon : eyeOffIcon"
          density="compact"
          :error="form.invalid('password_confirmation')"
          :error-messages="form.errors.password_confirmation"
          :placeholder="t('password_confirmation')"
          :type="showPasswordConfirmation ? 'text' : 'password'"
          variant="outlined"
          @click:append-inner="showPasswordConfirmation = !showPasswordConfirmation"
          @click:clear="form.validate('password_confirmation')"
        />
      </v-col>
      <v-col class="mt-4 pt-0" cols="12">
        <v-btn
          block
          class="text-subtitle-1 font-weight-bold"
          color="primary"
          :disabled="form.processing"
          height="48"
          rounded="md"
          size="large"
          style="font-weight: 500"
          type="submit"
          variant="flat"
        >
          <i18n-t keypath="save_changes" />
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
  <v-snackbar v-model="snackbar" close-delay="5" close-on-content-click :color="snackbarColor">
    <div class="text-center">{{ snackbarText }}</div>
  </v-snackbar>
</template>

<style scoped lang="scss">

:deep(.v-field) {
  font-size: 0.875rem;
}
</style>
